import { useEffect } from 'react'
import { useFetchChords } from '../../../../hooks/tasks/use-fetch-chords'
import { useStorePlayer } from '../store'
import { Summary } from '../../../../types'

interface UseChordsDataType {
  beatschords: Summary['beatschords']
}

export const useChordsData = ({ beatschords }: UseChordsDataType): void => {
  const { setData } = useStorePlayer()
  const { chords, error, loading } = useFetchChords(beatschords?.chords?.path)

  useEffect(() => {
    const updateInProgress = !!beatschords?.updateInProgress

    setData({
      chords: {
        data: chords,
        empty: !beatschords,
        status: updateInProgress
          ? 'update'
          : error || beatschords?.status === 'FAILED'
          ? 'failed'
          : loading
          ? 'loading'
          : beatschords?.status === 'QUEUED' ||
            beatschords?.status === 'STARTED'
          ? 'processing'
          : beatschords
          ? 'succeeded'
          : undefined
      }
    })
  }, [beatschords, error, loading, chords, setData])
}
